module.exports = require("pkg-up");